"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var query_params_util_1 = require("../../reverb-js-common/query_params_util");
var template = require("@reverbdotcom/url-template");
var constants_1 = require("../../reverb-js-common/constants");
var image_urls_1 = require("@reverbdotcom/commons/dist/image_urls");
var CLOUDINARY_HOST = 'https://res.cloudinary.com';
var CLOUDINARY_PATH = 'image/upload';
var CLOUD_NAME = CLOUDINARY_ENV === 'production' ? 'reverb' : 'reverb-dev';
var ADMIN_ROUTES = {
    pagesEdit: template.parse('/pages/{uuid}/edit'),
};
var DEFAULT_TRANSFORM = 'thumb_large';
function withAPIHost(path) {
    if (CORE_API_HOST) {
        return CORE_API_HOST + path;
    }
    return path;
}
function withLPHost(path) {
    return LP_HOST + path;
}
function isRoutable(countryCode) {
    if (!countryCode) {
        return false;
    }
    return constants_1.default.REGION_FILTER_CODES.indexOf(countryCode.toLowerCase()) >= 0;
}
exports.myWatchesPath = '/watched_products';
exports.watchesPath = template.parse(withAPIHost('/api/watches{?per_page}'));
exports.articlesPath = template.parse(withAPIHost('/api/articles{?per_page}'));
exports.brandsApiPath = template.parse(withAPIHost('/api/brands{?slugs}'));
exports.cspsApiPath = template.parse(withAPIHost('/api/csps{?page,per_page}'));
exports.cspsFindPath = template.parse(withAPIHost('/api/csps/find{?id,slug}'));
exports.shopPath = template.parse('/shop/{slug}');
exports.shopFeedbackPath = template.parse('/shop/{slug}/feedback');
exports.shopInfoPath = template.parse('/shop/{slug}/about');
exports.shopPromotePath = template.parse('/shop/{slug}/promote');
exports.adminEditUserPath = template.parse('/admin/users/{id}');
exports.marketplacePath = template.parse('/marketplace{/product_type,category}');
exports.brandManagerPath = template.parse('/brand-manager{/brand_slug}{/csp_slug}{?condition,created_after,created_before}');
exports.ITEM_WITH_SLUG_ROUTE = template.parse('/item/{id}-{slug}');
exports.ITEM_WITHOUT_SLUG_ROUTE = template.parse('/item/{id}');
exports.MARKETPLACE_ROUTE = 'marketplace(/:product_type(/:category))';
exports.FULL_MARKETPLACE_ROUTE = template.parse('/marketplace{/product_type,category}{?query*}');
exports.WEB_DEVICE = 'web';
exports.MOBILE_NATIVE_DEVICES = ['ios', 'android'];
exports.MOBILE_NATIVE_PROTOCOL = 'reverb-mobile-internal://';
exports.PRICE_GUIDE_ROUTE = 'price-guide(/:categorySlug(/:subcategorySlug))';
exports.priceGuidePath = template.parse('/price-guide{categorySlug,subCategorySlug}');
var TRANSACTION_SUMMARY_PATTERN = withAPIHost('/api/csps/{cspId}/transactions/summary{?number_of_months,condition}');
exports.TRANSACTION_SUMMARY_PATH = template.parse(TRANSACTION_SUMMARY_PATTERN);
var TRANSACTION_HISTORY_PATTERN = withAPIHost('/api/csps/{cspId}/transactions{?condition,per_page}');
exports.TRANSACTION_HISTORY_PATH = template.parse(TRANSACTION_HISTORY_PATTERN);
function isMobileNativeDevice(deviceName) {
    return exports.MOBILE_NATIVE_DEVICES.includes(deviceName);
}
exports.isMobileNativeDevice = isMobileNativeDevice;
function coreImageURLs(images, transform) {
    if (transform === void 0) { transform = DEFAULT_TRANSFORM; }
    return image_urls_1.coreImageURLs(images, transform, CORE_IMAGE_CDN);
}
exports.coreImageURLs = coreImageURLs;
function lPImageURLs(images, transform) {
    if (transform === void 0) { transform = DEFAULT_TRANSFORM; }
    return image_urls_1.lPImageURLs(images, transform, LP_UPLOAD_IMAGE_CDN);
}
exports.lPImageURLs = lPImageURLs;
var URLHelpers = /** @class */ (function () {
    function URLHelpers() {
    }
    URLHelpers.digitalListingPath = function (id) {
        return withAPIHost("/api/digital_listings/" + id);
    };
    URLHelpers.listingPagePath = function (id, slug) {
        if (slug) {
            return exports.ITEM_WITH_SLUG_ROUTE.expand({ id: id, slug: slug });
        }
        return exports.ITEM_WITHOUT_SLUG_ROUTE.expand({ id: id });
    };
    URLHelpers.listingsGridPath = function () {
        return withAPIHost('/api/listings/grid');
    };
    URLHelpers.flatCategoriesPath = function () {
        return withAPIHost('/api/categories/flat');
    };
    URLHelpers.softwarePath = function (categorySlug) {
        if (categorySlug) {
            return "/software/" + categorySlug;
        }
        return '/software';
    };
    URLHelpers.signupPath = function (params) {
        return "/signup/" + params;
    };
    URLHelpers.curatedSetFetchNotePath = function (listingId) {
        return withAPIHost("/api/my/curated_set_memberships/" + listingId);
    };
    URLHelpers.curatedSetSaveNotePath = function (curatedSetId, listingId) {
        return withAPIHost("/api/my/curated_set/" + curatedSetId + "/product/" + listingId);
    };
    URLHelpers.ordersManagerPath = function () {
        return this.ordersManagerSearchResultsPath();
    };
    URLHelpers.ordersManagerSearchResultsPath = function () {
        return '/my/selling/orders';
    };
    URLHelpers.orderPath = function (params) {
        return template.parse('/my/selling/orders/{orderId}{#anchor}').expand(params);
    };
    URLHelpers.orderTrackingPath = function (orderId) {
        return "/my/selling/orders/" + orderId + "/tracking";
    };
    URLHelpers.purchaseIndexPath = function () {
        return '/my/buying/orders';
    };
    URLHelpers.purchasePath = function (params) {
        return template.parse('/my/buying/orders/{orderId}{#anchor}{?actions_expanded}').expand(params);
    };
    URLHelpers.newFeedbackPath = function (orderId) {
        return "/my/feedback/new/" + orderId;
    };
    URLHelpers.packingSlipPath = function (orderId) {
        return "/my/orders/" + orderId + "/packing_slip.pdf";
    };
    URLHelpers.handpickedPath = function (curatedSetSlug, params) {
        if (params === void 0) { params = {}; }
        return "/handpicked/" + curatedSetSlug + query_params_util_1.default.queryParamsForUrl(params);
    };
    URLHelpers.cspCollectionPath = function (curatedSetSlug) {
        return "/collection/" + curatedSetSlug;
    };
    URLHelpers.articlesRecentlyFeaturedPath = function () {
        return withAPIHost('/api/articles/recently_featured');
    };
    URLHelpers.brandsApi = function () {
        return withAPIHost('/api/brands');
    };
    URLHelpers.articlesMultiplePath = function () {
        return withAPIHost('/api/articles/multiple');
    };
    URLHelpers.shopApiPath = function (slug, params) {
        if (params === void 0) { params = {}; }
        return withAPIHost("/api/shops/" + slug + query_params_util_1.default.queryParamsForUrl(params));
    };
    URLHelpers.feedbackApiPath = function (slug, params) {
        if (params === void 0) { params = {}; }
        return withAPIHost("/api/shops/" + slug + "/feedback" + query_params_util_1.default.queryParamsForUrl(params));
    };
    URLHelpers.buyerFeedbackApiPath = function (slug, params) {
        if (params === void 0) { params = {}; }
        return withAPIHost("/api/shops/" + slug + "/feedback/buyer" + query_params_util_1.default.queryParamsForUrl(params));
    };
    URLHelpers.sellerFeedbackApiPath = function (slug, params) {
        if (params === void 0) { params = {}; }
        return withAPIHost("/api/shops/" + slug + "/feedback/seller" + query_params_util_1.default.queryParamsForUrl(params));
    };
    URLHelpers.feedbackSummaryApiPath = function (slug) {
        return withAPIHost("/api/shops/" + slug + "/feedback_summary");
    };
    URLHelpers.ordersManagerSidebarFacetsPath = function (params) {
        return "/my/selling/orders/sidebar_facets" + query_params_util_1.default.queryParamsForUrl(params);
    };
    URLHelpers.ordersManagerOrderFacetsPath = function (params) {
        return "/my/selling/orders/order_facets" + query_params_util_1.default.queryParamsForUrl(params);
    };
    URLHelpers.sellingExportsOrdersPath = function () {
        return '/my/selling/exports/orders';
    };
    URLHelpers.sellingExportsPaymentsPath = function () {
        return '/my/selling/exports/payments';
    };
    URLHelpers.mySellingStatementsPath = function (params) {
        if (params === void 0) { params = {}; }
        return "/my/selling/statements" + query_params_util_1.default.queryParamsForUrl(params);
    };
    Object.defineProperty(URLHelpers, "myListingsPath", {
        get: function () {
            return withAPIHost('/api/my/listings');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.myListingsForCuratedSet = function (queryString) {
        return withAPIHost("/api/my/listings/curated_sets" + queryString);
    };
    URLHelpers.curatedSetAddListings = function (curatedSetId, queryString) {
        return "/my/selling/curated_sets/" + curatedSetId + "/add_listings" + queryString;
    };
    URLHelpers.curatedSetRemoveListings = function (curatedSetId, queryString) {
        return "/my/selling/curated_sets/" + curatedSetId + "/remove_listings" + queryString;
    };
    URLHelpers.relatedArticlesToListing = function (listingId) {
        return withAPIHost("/api/listings/" + listingId + "/related_articles");
    };
    URLHelpers.similarListings = function (listingId) {
        return withAPIHost("/api/listings/" + listingId + "/similar_listings");
    };
    URLHelpers.cspCategories = function () {
        return withAPIHost('/api/csps/categories');
    };
    URLHelpers.cspsPath = function () {
        return withAPIHost('/api/csps');
    };
    // This path is currently blocked by AdBlock. We are going to continue
    // to allow (for now) AdBlock users to block these inline callouts but
    // pivot to /api/csps to evade that block for use outside of the blog
    URLHelpers.cspsEmbedPath = function () {
        return withAPIHost('/api/comparison_shopping_pages');
    };
    URLHelpers.cspConditionPath = function (params) {
        return template.parse('/p/{slug}/{condition}{?filters*}').expand(params);
    };
    URLHelpers.cspPath = function (cspSlug) {
        return "/p/" + cspSlug;
    };
    URLHelpers.similarCSPsPath = function (strategy) {
        return withAPIHost("/api/csps/" + strategy);
    };
    URLHelpers.categoriesFlatPath = function () {
        return withAPIHost('/api/categories/flat');
    };
    URLHelpers.bumpClickTrackingPath = function (listingId, bumpClickUuid) {
        return "/bump/clicks?b=" + bumpClickUuid + "&listing_id=" + listingId;
    };
    Object.defineProperty(URLHelpers, "bumpTrackingPath", {
        get: function () {
            return '/bump/impressions/track_multiple';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.brandCollectionHeaderPath = function (slug) {
        return withAPIHost("/api/brands/" + slug + "/collection_header");
    };
    URLHelpers.brandsPath = function (slug) {
        return withAPIHost("/api/brands/" + slug);
    };
    URLHelpers.categoryCollectionHeaderPath = function (categoryUuidOrSlug) {
        return withAPIHost("/api/categories/" + categoryUuidOrSlug + "/collection_header");
    };
    URLHelpers.categoryCollectionHeadersPath = function (rootSlug, childSlug) {
        return withAPIHost("/api/categories/collection_headers?root_slug=" + rootSlug + "&child_slug=" + childSlug);
    };
    URLHelpers.curatedSetCollectionHeaderPath = function (slug) {
        return withAPIHost("/api/curated_sets/" + slug + "/collection_header");
    };
    URLHelpers.curatedSetsPath = function () {
        return withAPIHost('/api/curated_sets');
    };
    URLHelpers.curatedSetPath = function (slug) {
        return withAPIHost("/api/curated_sets/" + slug);
    };
    URLHelpers.userCuratedSetProductsPath = function () {
        return withAPIHost('/api/my/curated_set/products');
    };
    URLHelpers.userCuratedSetProductPath = function (id) {
        return withAPIHost("/api/my/curated_set/product/" + id);
    };
    URLHelpers.curatedSetsHomepagePath = function () {
        return withAPIHost('/api/curated_sets/homepage');
    };
    URLHelpers.curatedSearchCollectionHeaderPath = function (slug) {
        return withAPIHost("/api/curated_searches/" + slug + "/collection_header");
    };
    URLHelpers.landingPageCollectionHeaderPath = function (slug) {
        return withAPIHost("/api/landing_pages/" + slug + "/collection_header");
    };
    URLHelpers.productTypeCollectionHeaderPath = function (slug) {
        return withAPIHost("/api/product_types/" + slug + "/collection_header");
    };
    Object.defineProperty(URLHelpers, "listingsManagerUserDataPath", {
        get: function () {
            return '/my/selling/listings/user_data';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.listingPath = function (id) {
        return withAPIHost("/api/listings/" + id + "?skip_product_view_tracking=true");
    };
    Object.defineProperty(URLHelpers, "myAddressesIndexPath", {
        get: function () {
            return withAPIHost('/api/my/addresses');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.myAddressesCreatePath = function () {
        return withAPIHost('/api/my/addresses/');
    };
    URLHelpers.myAddressesUpdatePath = function (addressId) {
        return withAPIHost("/api/my/addresses/" + addressId);
    };
    URLHelpers.myAddressesDeletePath = function (addressId) {
        return withAPIHost("/api/my/addresses/" + addressId);
    };
    Object.defineProperty(URLHelpers, "countriesPath", {
        get: function () {
            return withAPIHost('/api/countries');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "listingsManagerSidebarFacetsPath", {
        get: function () {
            return '/my/selling/listings/sidebar_facets';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "listingsManagerListingResultsPath", {
        get: function () {
            return '/my/selling/listings/listing_results';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.myOffersOfferCard = function (negotiationId) {
        return "/my/offers/" + negotiationId + "/offer_card";
    };
    Object.defineProperty(URLHelpers, "categoriesWithTraitsPath", {
        get: function () {
            return withAPIHost('/api/categories/traits');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.listingProductReviewsPath = function (listingId) {
        return withAPIHost("/api/listings/" + listingId + "/reviews");
    };
    URLHelpers.shipmentPath = function (params) {
        return template.parse('/my/selling/shipping_labels/{shipmentId}{?orderId,checkoutUuid}').expand(params);
    };
    URLHelpers.editShipmentPath = function (params) {
        return template.parse('/my/selling/shipping_labels/{shipmentId}/edit{?orderId,checkoutUuid}').expand(params);
    };
    Object.defineProperty(URLHelpers, "cartPath", {
        get: function () {
            return '/cart';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "productBundleCartPath", {
        get: function () {
            return '/cart/add_product_bundle';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "apiCartPath", {
        get: function () {
            return '/web_api/cart';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "changeShippingRegionPath", {
        get: function () {
            return '/users/international_settings?tab=shipping-region-form';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.cmsPagePath = function (pageSlug) {
        return "/page/" + pageSlug;
    };
    URLHelpers.cms2PagePath = function (categorySlug) {
        return "/c/" + categorySlug;
    };
    URLHelpers.lpNewArrivalsUrl = function () {
        return withLPHost('/c/new-arrivals');
    };
    Object.defineProperty(URLHelpers, "shippingProtectionPath", {
        get: function () {
            return '/page/shipping-guide#reverb-shipping-protection';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "sellerProtectionPath", {
        get: function () {
            return '/page/reverb-protection';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "affirmFaqPath", {
        get: function () {
            return '/page/affirm-faqs';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "termsOfUsePath", {
        get: function () {
            return '/page/terms';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "privacyPolicyPath", {
        get: function () {
            return '/page/privacy';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "gdprPolicyPath", {
        get: function () {
            return '/page/eu-data-transfer-GDPR';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "shippingGuidePath", {
        get: function () {
            return '/page/shipping-guide';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "facebookAuthPath", {
        get: function () {
            return '/auth/facebook';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "passwordResetPath", {
        get: function () {
            return '/forgot_password';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.adminEditCspPath = function (cspSlug) {
        return "/admin/comparison_shopping_pages/" + cspSlug + "/edit";
    };
    URLHelpers.adminBlockReview = function (id) {
        return "/admin/product_reviews/" + id + "/block";
    };
    URLHelpers.adminEditCuratedSetPath = function (curatedSetSlug) {
        return "/admin/curated_sets/" + curatedSetSlug + "/edit";
    };
    URLHelpers.adminEditBrandPath = function (brandSlug) {
        return "/admin/brands/" + brandSlug + "/edit_from_slug";
    };
    URLHelpers.adminRenameBrandPath = function (brandSlug) {
        return "/admin/brands/" + brandSlug + "/rename_from_slug";
    };
    Object.defineProperty(URLHelpers, "feedGridPath", {
        get: function () {
            return withAPIHost('/api/my/feed/grid');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "feedCustomizePath", {
        get: function () {
            return withAPIHost('/api/my/feed/customize');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "articleFollowPath", {
        get: function () {
            return withAPIHost('/api/my/follows/articles');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.myFollowsSearchPath = function () {
        return withAPIHost('/api/my/follows/search');
    };
    URLHelpers.newsletterSignup = function (id) {
        return "/mailchimp_subscriptions?list_id=" + id;
    };
    URLHelpers.brandPath = function (brandSlug) {
        return "/brand/" + brandSlug;
    };
    URLHelpers.brandDrilldownPath = function (brandSlug, categoryPath) {
        return "/brand/" + brandSlug + "/c" + categoryPath;
    };
    URLHelpers.salePath = function (saleSlug) {
        return "/sales/" + saleSlug;
    };
    URLHelpers.cloudinaryImageUrl = function (path, transform) {
        // force jpg transformation of gallery to match pre-transformed images in cloudinary
        return [
            CLOUDINARY_HOST,
            CLOUD_NAME,
            CLOUDINARY_PATH,
            transform,
            path.replace(/.\w\w\w$/, '.jpg'),
        ].join('/');
    };
    Object.defineProperty(URLHelpers, "relatedArticlesPath", {
        get: function () {
            return withAPIHost('/api/articles/related');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "articlesAPIPath", {
        get: function () {
            return withAPIHost('/api/articles');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.articlesSearchPath = function (params) {
        return "/news" + query_params_util_1.default.queryParamsForUrl(params);
    };
    URLHelpers.shopPath = function (shopSlug) {
        return "/shop/" + shopSlug;
    };
    URLHelpers.shopFeedbackPath = function (shopSlug) {
        return "/shop/" + shopSlug + "/feedback";
    };
    URLHelpers.marketplacePath = function (condition) {
        if (condition === void 0) { condition = 'used'; }
        return "/marketplace?condition=" + condition;
    };
    URLHelpers.marketplaceBrandCategoryPath = function (make, categoryPath) {
        if (categoryPath === void 0) { categoryPath = ''; }
        return "/marketplace" + categoryPath + query_params_util_1.default.queryParamsForUrl({ make: make });
    };
    URLHelpers.marketplaceCategoryPath = function (categoryPath) {
        return "/marketplace" + categoryPath;
    };
    URLHelpers.closeNagAlertPath = function (nagId) {
        return "/nag_alerts/" + nagId + "/close";
    };
    URLHelpers.personalProfilePath = function (slug) {
        return "/profile/" + slug;
    };
    URLHelpers.personalProfileFollowersPath = function (slug) {
        return "/profile/" + slug + "/followers";
    };
    Object.defineProperty(URLHelpers, "shopEditPath", {
        get: function () {
            return '/my/shop/edit';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "accountEditPath", {
        get: function () {
            return '/my/account/settings';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "appleAppStorePath", {
        get: function () {
            return 'https://itunes.apple.com/app/reverb.com/id674604876';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "googlePlayStorePath", {
        get: function () {
            return 'https://play.google.com/store/apps/details?id=com.reverb.app';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.buyerPath = function (id) {
        return "/buyers/" + id;
    };
    Object.defineProperty(URLHelpers, "redirectsPath", {
        get: function () {
            return withAPIHost('/api/listings/redirects');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.autocompletePath = function (query) {
        return "/autocomplete?q=" + encodeURIComponent(query);
    };
    URLHelpers.marketplaceQuery = function (query) {
        return "/marketplace?query=" + encodeURIComponent(query);
    };
    Object.defineProperty(URLHelpers, "myShopPath", {
        get: function () {
            return withAPIHost('/api/shop');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myShopBillingCardPath", {
        get: function () {
            return withAPIHost('/api/my/shop/billing_card');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.cspReviewsUrl = function (cspSlug, page, perPage) {
        return URLHelpers.CSP_REVIEWS_TEMPLATE.expand({
            cspSlug: cspSlug,
            page: page,
            per_page: perPage,
        });
    };
    URLHelpers.cspUpdateReviewUrl = function (reviewId) {
        return URLHelpers.CSP_UPDATE_REVIEWS_TEMPLATE.expand({ reviewId: reviewId });
    };
    URLHelpers.myCreditCardsCreatePath = function () {
        return '/api/my/credit_cards/';
    };
    URLHelpers.myCreditCardPath = function (creditCardId) {
        return "/api/my/credit_cards/" + creditCardId;
    };
    URLHelpers.myCreditCardsPath = function (params) {
        return template.parse(withAPIHost('/api/my/credit_cards{?per_page}')).expand(params);
    };
    Object.defineProperty(URLHelpers, "myDirectCheckoutProfilePath", {
        get: function () {
            return '/api/shop/payment_methods/direct_checkout';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myPaypalProfilePath", {
        get: function () {
            return '/api/shop/payment_methods/paypal';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "directCheckoutPath", {
        get: function () {
            return '/api/shop/payment_methods/direct_checkout';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "contactUsPath", {
        get: function () {
            return '/page/contact';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "holidaySalePath", {
        get: function () {
            return '/holiday';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "coreIdentityVerificationPath", {
        get: function () {
            return '/my/selling/identity_verification';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "coreBankAccountVerificationPath", {
        get: function () {
            return '/my/selling/identity_verification/bank_account';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "corePhotoIDVerificationPath", {
        get: function () {
            return '/my/selling/identity_verification/photo_id';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "coreShopOwnerVerificationPath", {
        get: function () {
            return '/my/selling/identity_verification/shop_owner';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "coreCompanyDataVerificationPath", {
        get: function () {
            return '/my/selling/identity_verification/company_data';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "lpIdentityVerificationPath", {
        get: function () {
            return '/my/selling/lp_identity_verification';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "lpBankAccountVerificationPath", {
        get: function () {
            return '/my/selling/lp_identity_verification/bank_account';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "lpPhotoIDVerificationPath", {
        get: function () {
            return '/my/selling/lp_identity_verification/photo_id';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "lpShopOwnerVerificationPath", {
        get: function () {
            return '/my/selling/lp_identity_verification/shop_owner';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "lpCompanyDataVerificationPath", {
        get: function () {
            return '/my/selling/lp_identity_verification/company_data';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.lpListingDefaultUrl = function (listingID, params) {
        if (params === void 0) { params = {}; }
        var path = template.parse("/listings/" + listingID + "/listings{?modal}").expand(params);
        return withLPHost(path);
    };
    URLHelpers.editDirectCheckoutCreditCardPath = function (checkoutId, creditCardId) {
        return template.parse('/multi-checkout/{checkoutId}/direct/edit_credit_card/{creditCardId}').expand({ checkoutId: checkoutId, creditCardId: creditCardId });
    };
    URLHelpers.lpShopUrl = function (slug) {
        return withLPHost("/shops/" + slug + "/listings");
    };
    Object.defineProperty(URLHelpers, "coreBankAccountPath", {
        get: function () {
            return '/my/selling/bank_account';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "shopOnboardingSetupPath", {
        get: function () {
            return '/shop_onboarding/setup';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.shopOnboardingSetupPathWithSelectedPaymentMethod = function (selectedPaymentMethod, listingId) {
        var _a;
        var queryParam = query_params_util_1.default.queryParamsForUrl((_a = {}, _a["" + selectedPaymentMethod] = true, _a.listing_id = listingId, _a));
        if (queryParam) {
            return "" + this.shopOnboardingSetupPath + queryParam;
        }
        return this.shopOnboardingSetupPath;
    };
    Object.defineProperty(URLHelpers, "shopOnboardingShopDetailsPath", {
        get: function () {
            return '/shop_onboarding/shop_details';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "shopOnboardingReverbPaymentsPaymentSettingsPath", {
        get: function () {
            return '/shop_onboarding/reverb_payments/payment_settings';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "shopOnboardingReverbPaymentsIdentityVerificationPath", {
        get: function () {
            return '/shop_onboarding/reverb_payments/identity_verification';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "shopOnboardingReverbPaymentsFinishPath", {
        get: function () {
            return '/shop_onboarding/reverb_payments/finish';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "onboardingPath", {
        get: function () {
            return '/shop_onboarding/setup';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "onboardingCompleteShopDetailsPath", {
        get: function () {
            return '/shop_onboarding/reverb_payments/complete_shop_details';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "onboardingBegin3DS1", {
        get: function () {
            return '/shop_onboarding/begin_3ds1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "setupShopPaymentMethodsPath", {
        get: function () {
            return withAPIHost('/api/my/shop/setup_payment_methods');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "identityVerificationChecksPath", {
        get: function () {
            return withAPIHost('/api/my/kyc/verification_checks');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myKYCPath", {
        get: function () {
            return withAPIHost('/api/my/kyc');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myShopKYCPath", {
        get: function () {
            return withAPIHost('/api/my/shop/kyc');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myShopBankAccountPath", {
        get: function () {
            return withAPIHost('/api/my/shop/bank_account');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myShopOwnerPath", {
        get: function () {
            return withAPIHost('/api/my/shop/owner');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myShopCompanyPath", {
        get: function () {
            return withAPIHost('/api/my/shop/company');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myKYCPresignedS3UrlPath", {
        get: function () {
            return withAPIHost('/api/my/kyc/presigned_s3_url');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myKYCBankAccountVerificationPath", {
        get: function () {
            return withAPIHost('/api/my/kyc/verification_checks/bank_account');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myKYCPhotoIDVerificationPath", {
        get: function () {
            return withAPIHost('/api/my/kyc/verification_checks/photo_id');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "myShopConvertShopTypePath", {
        get: function () {
            return withAPIHost('/api/my/shop/convert_shop_type');
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.watchProductPath = function (productId) {
        return "/watched_products?id=" + productId;
    };
    URLHelpers.unwatchProductPath = function (productId) {
        return "/watched_products/" + productId;
    };
    URLHelpers.sellFormSearchPath = function (query) {
        return template.parse('/sell/search{?query}').expand(query);
    };
    Object.defineProperty(URLHelpers, "convertShopTypePath", {
        get: function () {
            return '/my/shop/convert_shop_type';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "convertShopTypeFinishPath", {
        get: function () {
            return '/my/shop/convert_shop_type/finish';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "reverbSitesPath", {
        get: function () {
            return '/page/reverb-sites';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "sellerHub", {
        get: function () {
            return '/page/seller-hub';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "dashboardPath", {
        get: function () {
            return '/my/account';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.prefilledListingFromCSPPath = function (cspId) {
        return template.parse('/sell_prefilled{?seed_id}').expand({ seed_id: cspId });
    };
    URLHelpers.cmsAdminRoute = function (name, params) {
        if (params === void 0) { params = {}; }
        var template = ADMIN_ROUTES[name];
        var path = template.expand(params);
        return "" + CMS_ADMIN_HOST + path;
    };
    Object.defineProperty(URLHelpers, "reverbProtectionPath", {
        get: function () {
            return '/page/reverb-protection';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLHelpers, "reverbPaymentsFaqPath", {
        get: function () {
            return '/page/direct-checkout-faq#when-will-i-get-paid';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.newDashboardMessagesPath = function (listingId, recipientUuid) {
        return template.parse('/my/messages/new{?item,recipient_uuid}').expand({
            item: listingId,
            recipient_uuid: recipientUuid,
        });
    };
    URLHelpers.soundcloudPath = function (params) {
        return "https://w.soundcloud.com/player/" + query_params_util_1.default.queryParamsForUrl(params);
    };
    URLHelpers.urlByRegion = function (url, countryCode) {
        if (isRoutable(countryCode)) {
            return "/" + countryCode.toLowerCase() + url;
        }
        return url;
    };
    URLHelpers.mobileNativeCaptureUrl = function (relativeUrl) {
        return exports.MOBILE_NATIVE_PROTOCOL + relativeUrl;
    };
    Object.defineProperty(URLHelpers, "dashboardSellingPayoutsPath", {
        get: function () {
            return '/dashboard/selling/payouts';
        },
        enumerable: true,
        configurable: true
    });
    URLHelpers.CSP_REVIEWS_TEMPLATE = template.parse(withAPIHost('/api/products/{cspSlug}/reviews{?page,per_page}'));
    URLHelpers.CSP_UPDATE_REVIEWS_TEMPLATE = template.parse(withAPIHost('/api/products/reviews/{reviewId}'));
    URLHelpers.FEED_GRID_TEMPLATE = template.parse(URLHelpers.feedGridPath + "{?page,per_page}");
    return URLHelpers;
}());
exports.default = URLHelpers;
//# sourceMappingURL=url_helpers.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/url_helpers.js
// module id = 9bkk
// module chunks = 20 21 22